module.exports = __webpack_public_path__ + "static/img/shanghai-baoye.38caa417.png";